import React, { CSSProperties, FC, useMemo } from 'react';
import classNames from 'classnames';
import { gray } from '../../../../../../ReactSharedScripts/components/Color';
import classes from './styles/detailPage.module.scss';
import { DetailPageContent } from './DetailPageContent';
import { DetailPageContentProps } from 'modules/detailPage/components/DetailPage/DetailPageContent';

type DetailPageComponents = {
	Content: FC<React.PropsWithChildren<DetailPageContentProps>>;
};

type DetailPageProps = {
	className?: string;
	backgroundColor?: string;
	dataTestId?: string;
};

export const DetailPage: FC<React.PropsWithChildren<DetailPageProps>> & DetailPageComponents = ({
	children,
	className,
	dataTestId,
	backgroundColor = gray[0],
}) => {
	const componentClasses = classNames(classes.detailPage, className);

	const componentStyles = useMemo<CSSProperties>(
		() => ({
			backgroundColor,
		}),
		[backgroundColor],
	);

	return (
		<div
			className={componentClasses}
			style={componentStyles}
			data-testid={dataTestId}
		>
			{children}
		</div>
	);
};

DetailPage.Content = DetailPageContent;
